import { useCallback, useState, Dispatch, SetStateAction } from 'react'

const useSelectStore = (
  initialState: string[]
): [
  addStore: () => void,
  removeStore: (index: number) => void,
  handleStores: (value: string, index: number) => void,
  setStoreIds: Dispatch<SetStateAction<string[]>>,
  storeIds: string[]
] => {
  const [storeIds, setStoreIds] = useState<string[]>(initialState)
  const addStore = useCallback(() => setStoreIds((prevState) => [...prevState, '']), [setStoreIds])
  const removeStore = useCallback(
    (index: number) => {
      setStoreIds((prevState) => [...prevState.filter((_, i) => i !== index)])
    },
    [setStoreIds]
  )
  const handleStores = useCallback(
    (value: string, index: number) => {
      setStoreIds((prevState) => {
        if (prevState.includes(value)) return prevState
        const nextState = prevState
        nextState[index] = value
        return [...nextState]
      })
    },
    [setStoreIds]
  )
  return [addStore, removeStore, handleStores, setStoreIds, storeIds]
}

export default useSelectStore
